module.exports = __webpack_public_path__ + "static/media/IconHat.181d2830.svg";